import script from "./ControlButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlButtons.vue?vue&type=script&setup=true&lang=js"

import "./ControlButtons.vue?vue&type=style&index=0&id=2ce99726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce99726"]])

export default __exports__